import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import BackButton from "./Components/BackButton";
import { HeaderOptions } from "./Components/HeaderOptions";

import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type AppUserSession } from "@/schemas/auth/session";
import { UserRestrictionType } from "@/schemas/user/restriction";
import RestrictionService from "@/services/user/restriction";
import { useMessageContext } from "@/context/messaging/StreamContext";
import { getChannelMembers, getChannelPartner } from "@/utils/messaging";

type ChannelHeaderProps = {
  session: AppUserSession;
};

function ChannelHeader({ session }: ChannelHeaderProps): React.JSX.Element {
  const { channel } = useMessageContext();
  const { setIsUserBlocked } = useHeaderContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isBlocked, setIsBlocked] = useState<boolean>(false);
  const chatPartnerName = getChannelPartner(channel) || "Chat";

  const onBlockToggle = async (newStatus: boolean): Promise<void> => {
    setIsBlocked(newStatus);
    await fetchIsChatDisabled();
  };

  const fetchBlockedRestriction = async (): Promise<void> => {
    //Todo;  This is a hack to not show the block button for group chats
    const members = getChannelMembers(channel);
    if (members.length > 2) {
      return;
    }

    setIsLoading(true);
    const restrictionService = new RestrictionService(session);
    const response = await restrictionService.checkRestriction(
      chatPartnerName,
      UserRestrictionType.BLOCKED,
    );
    setIsBlocked(response.isRestricted);
    setIsLoading(false);
  };

  const fetchIsChatDisabled = async (): Promise<void> => {
    //Todo;  This is a hack to not show the block button for group chats
    const members = getChannelMembers(channel);
    if (members.length > 2) {
      return;
    }

    setIsLoading(true);
    const restrictionService = new RestrictionService(session);
    const response = await restrictionService.checkRestriction(
      chatPartnerName,
      UserRestrictionType.BLOCKED,
    );
    setIsUserBlocked(response.isRestricted);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchBlockedRestriction();
    fetchIsChatDisabled();
  }, []);

  return (
    <SafeAreaView style={styles.safeArea} edges={["top"]}>
      <View style={styles.container}>
        <View style={styles.sideContainer}>
          <BackButton />
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.text}>{chatPartnerName}</Text>
        </View>
        <View
          style={[styles.sideContainerRight, { opacity: isLoading ? 0 : 1 }]}
        >
          <HeaderOptions
            session={session}
            target={chatPartnerName}
            isBlocked={isBlocked}
            onHandleBlockToggle={onBlockToggle}
            showGoToUserProfile={true}
          />
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  safeArea: {
    backgroundColor: "#fff",
  },
  text: {
    fontSize: 20,
  },
  sideContainer: {
    flex: 1,
    alignItems: "flex-start",
  },
  sideContainerRight: {
    flex: 1,
    alignItems: "flex-end",
  },
  titleContainer: {
    alignItems: "center",
  },
});

export default ChannelHeader;
